import React from 'react';
import ReactDOM from 'react-dom/client';

// 1. Import Bootstrap CSS first
import 'bootstrap/dist/css/bootstrap.min.css';
// 2. Import custom CSS after Bootstrap
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// PWA 설치 프롬프트(beforeinstallprompt)를 앱 초반부터 붙잡아 두기 위해 최상단에서 import
import './utils/pwaInstall';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';

// 3. Import the override file LAST to ensure it takes precedence
import './overrides.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();